import { render, staticRenderFns } from "./Concentrations.vue?vue&type=template&id=f43fb8c0&"
import script from "./Concentrations.vue?vue&type=script&lang=js&"
export * from "./Concentrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports